export enum UserFrontendLoginGoogleErrorEnum {
  POPUP_CLOSE = 'popup_closed_by_user',
}
